/**
 * URLs can be found in settings.provider.js
 * default headers are set in api.interceptor.js
 */

export const DataServiceModule = angular
    .module('app.services.data.dataService', [])
    .service('dataService', ($http) => {
        return {
            get,
            getAll,
            save,
            saveAll,
            create,
            copy,
            patch,
            remove,
            newOrders: 0,
            inProgress: 0
        };

        function get(endpoint, id, options, responseType = '') {
            return $http.get(getUrl(endpoint, id), {
                params: options,
                responseType
            }).then(response => response.data);
        }

        function getAll(endpoint, options, headers, returnHeaders = false) {
            const config = Object.assign({}, { params: options }, { headers });
            return $http.get(getUrl(endpoint), config)
                .then((response) => {
                    if (returnHeaders) {
                        return {
                            data: response.data,
                            headers: response.headers()
                        };
                    }

                    return response.data;
                });
        }

        function saveAll(endpoint, obj, headers) {
            return $http.put(getUrl(endpoint), obj, {
                headers: headers
            }).then(response => response.data);
        }

        function save(endpoint, id, obj, headers) {
            return $http.put(getUrl(endpoint, id), obj, {
                headers: headers
            }).then(response => response.data);
        }

        function create(endpoint, obj, headers, params) {
            return $http.post(getUrl(endpoint), obj, {
                headers,
                params
            }).then(response => response.data);
        }

        function copy(endpoint, obj, nameLength, headers) {
            nameLength = nameLength || 35;
            var strLength = nameLength - 7;

            obj.name = `${obj.name.substring(0, strLength)} - COPY`;
            return create(endpoint, obj, headers);
        }

        function remove(endpoint, id, headers) {
            return $http.delete(getUrl(endpoint, id), {
                headers: headers
            }).then(response => response.data);
        }

        function patch(endpoint, id, patches = [], headers) {
            return $http.patch(getUrl(endpoint, id), patches, {
                headers: headers
            }).then(response => response.data);
        }

        function getUrl(endpoint, id) {
            var url = `${process.env.BASE_API_URL}/${endpoint}`;

            if (id !== undefined && id !== null) {
                url += `/${id}`;
            }

            return url;
        }
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/services/data/data.service.js